import { MapPin } from 'lucide-react';
import { OohTrip } from '../../../../core/graphql/types';
import DeliveryTripCard from './DeliveryTripCard';

interface DeliveryTripsSectionProps {
  locationTrips: OohTrip[];
  expandedTrips: Set<number>;
  onToggleTripExpansion: (tripId: number) => void;
}

const DeliveryTripsSection = ({
  locationTrips,
  expandedTrips,
  onToggleTripExpansion,
}: DeliveryTripsSectionProps) => {
  const sortedLocationTrips = [...locationTrips].sort((a, b) => {
    if (!a.warehouseDepartureTime) return 1;
    if (!b.warehouseDepartureTime) return -1;
    
    return new Date(a.warehouseDepartureTime).getTime() - new Date(b.warehouseDepartureTime).getTime();
  });

  return (
    <div className="space-y-4">
      <div className="mb-4 flex items-center gap-2">
        <MapPin className="h-5 w-5 text-bright-blue" />
        <h3 className="text-lg font-semibold ">Delivery Trips</h3>
      </div>

      <div className="space-y-3">
        {sortedLocationTrips.length > 0 ? (
          sortedLocationTrips.map((locationTrip, index) => (
            <DeliveryTripCard
              key={index}
              locationTrip={locationTrip}
              tripIndex={index}
              isExpanded={expandedTrips.has(index)}
              onToggleExpansion={() => onToggleTripExpansion(index)}
            />
          ))
        ) : (
          <div className="flex items-center justify-center p-4">
            No courier trips to OOH points detected
          </div>
        )}
      </div>
    </div>
  );
};

export default DeliveryTripsSection;